import { SimpleDashboardContent } from 'features/dashboard/DashboardContent';
import { Outlet } from 'react-router-dom';
import { CreditCard } from 'lucide-react';
import { GenericViewHeader } from 'back-office/shared/components/GenericViewHeader';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { NsKey } from 'enums/NsKey';

export default function PaymentScheduleView() {
  const { t } = useDynamicTranslation([NsKey.Common])

  return (
    <SimpleDashboardContent>
      <GenericViewHeader
        title={t("SIDEBAR.PAYMENT_SCHEDULE_MANAGER")}
        icon={CreditCard}
      />
      <Outlet />
    </SimpleDashboardContent>
  );
}
